import { themeAlpine } from 'ag-grid-community';

export const gridTheme = themeAlpine.withParams({
  // Checkboxes
  checkboxUncheckedBackgroundColor: '#fff',
  checkboxCheckedShapeColor: '#fff',
  checkboxCheckedBorderColor: 'rgb(71, 169, 166)',
  checkboxCheckedBackgroundColor: '#47a9a6',
  checkboxUncheckedBorderColor: '#47a9a6',
  checkboxIndeterminateShapeColor: 'grey',
  checkboxIndeterminateBorderColor: 'grey',

  // Rows
  oddRowBackgroundColor: '#f9f9f9',
  rowBorder: '1px solid #ddd',
  selectedRowBackgroundColor: 'rgb(71 169 166 / 20%)',

  // Header & Chrome
  headerBackgroundColor: '#fff',
  chromeBackgroundColor: '#fff',

  // Typography
  fontFamily: 'Roboto, Calibri, Candara, Segoe, Segoe UI, Optima, Arial, sans-serif',
  fontSize: 13,

  // Tabs
  tabSelectedUnderlineColor: '#3FBAB3',
  tabSelectedUnderlineWidth: 3,
  tabSelectedUnderlineTransitionDuration: '0.5s',

  // Accent
  accentColor: '#3FBAB3',

  // Toggle Buttons
  toggleButtonOffBackgroundColor: '#d6d6d6',
  toggleButtonSwitchBackgroundColor: 'grey',

  // Root wrapper
  wrapperBorderRadius: 5
});

export const gridThemeNoBorder = gridTheme.withParams({
  wrapperBorder: false,
});

// TBD: Whether this is the "common" condensed style. 
// Must be used withParams whenever used to include with or without borders
export const condensedTheme = {
  cellHorizontalPaddingScale: 0.5,
  headerVerticalPaddingScale: 0.4,
  rowVerticalPaddingScale: 0.4,
  oddRowBackgroundColor: '#fff',
};
